import { ThemePreference } from '@App/app/entities/users/user';

export const THEME_ICONS: Record<ThemePreference, string> = {
  system: 'monitor',
  light: 'sun',
  dark: 'moon',
};

/** Short, human-readable name for each theme preference. */
export const THEME_OPTION_LABELS: Record<ThemePreference, string> = {
  light: 'Light',
  dark: 'Dark',
  system: 'System',
};

/** Order the theme options are listed in the header menu. */
export const THEME_OPTIONS: ThemePreference[] = ['light', 'dark', 'system'];

export interface HeaderMenuItem {
  title: string;
  link?: string;
  data: { id: string };
}

export const buildProfileMenuItems = (companyId: number): HeaderMenuItem[] => [
  { title: 'Profile', link: `/${companyId}/user`, data: { id: 'profile' } },
  { title: 'Log out', data: { id: 'logout' } },
];

interface UserRole {
  name: string;
}

export const computeUserRoles = (userRoles: UserRole[]): string => {
  if (userRoles.some((role) => role.name === 'Admin')) {
    return 'Admin';
  }

  return userRoles
    .filter((role) => role.name !== 'StandardUser')
    .map((role) => role.name)
    .join(', ');
};
